import { FAQData } from '../../../components/faq/types';

export const FAQ_API_PREFIX = 'faq';

/** Convert rendered <img> tags back into #img:...# placeholders for editing. */
export function convertImagesToPlaceholders(html: string): string {
  try {
    if (typeof document === 'undefined') return html;
    const wrapper = document.createElement('div');
    wrapper.innerHTML = html || '';
    const imgs = Array.from(wrapper.getElementsByTagName('img'));
    for (const img of imgs) {
      const src = img.getAttribute('src') || '';
      const alt = img.getAttribute('alt') || '';
      let placeholder: string | null = null;
      if (src.startsWith('/assets/faq/')) {
        const rel = src.replace(/^\/assets\/faq\//, '');
        placeholder = `#img:faq/${rel}:${alt || rel}#`;
      } else if (src.startsWith('/api/images/')) {
        const rel = src.replace(/^\//, '');
        placeholder = `#img:${rel}:${alt || rel}#`;
      }
      if (placeholder) {
        const textNode = document.createTextNode(placeholder);
        img.parentNode?.replaceChild(textNode, img);
      }
    }
    return wrapper.innerHTML;
  } catch (_e) {
    return html;
  }
}

export function mapAnswers(input: FAQData, mapFn: (html: string) => string): FAQData {
  return {
    groups: input.groups.map((g) => ({
      group: g.group,
      items: g.items.map((it) => ({
        question: it.question,
        answer: mapFn(it.answer || ''),
      })),
    })),
  };
}

export function toPlainText(input: string): string {
  const div = document.createElement('div');
  div.innerHTML = input;
  return div.innerText;
}

export function buildPublicAssetImagePlaceholder(filename: string, alt: string): string {
  return `#img:faq/${filename}:${alt || filename}#`;
}

export function buildApiImageUploadPlaceholder(relativePath: string, alt: string): string {
  return `#img:api/images/${relativePath}:${alt}#`;
}

export function buildFaqLinkPlaceholder(group: string, question?: string): string {
  return question ? `#link:${group}:${question}#` : `#link:${group}#`;
}

export function downloadJsonFile(json: unknown, filename: string): void {
  const text = JSON.stringify(json, null, 2);
  const blob = new Blob([text], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
